exports.components = {
  "component---src-core-pages-page-template-tsx": () => import("./../../../src/core/pages/PageTemplate.tsx" /* webpackChunkName: "component---src-core-pages-page-template-tsx" */),
  "component---src-core-share-share-block-template-tsx": () => import("./../../../src/core/share/ShareBlockTemplate.tsx" /* webpackChunkName: "component---src-core-share-share-block-template-tsx" */)
}

